// extracted by mini-css-extract-plugin
export default {"socials-list":"SocialsList_socials-list__42xdf"};